export const lsConstants = {
  TOKEN_EXPIRES: "tokenExpires",
  FEATURE_FLAGS: "ff",
  WORKSPACE_ID: "workspaceId",
  NAV_EXPANDED: "nav_expanded",
  NEW_PACKAGES: "newPackages",
  NEW_DASHBOARD: "newDashboard",
  REDIRECT: "redirect",
};
